<div class="page-container" [class.is-authenticated]="isAuthenticated$ | async">
  @if (isAuthenticated$ | async) {
    <app-main-navigation class="navigation-container" />
    <app-page-header class="header-container" />
  }

  <div class="main-container">
    @if (!(isSystemRunning$ | async)) {
      <app-system-stop
        @fadeSlide
        [isEmegancyStopActive$]="isEmegancyStopActive$"
        [isSystemRunning$]="isSystemRunning$"
        (triggerKillSwitch)="onTriggerKillSwitch($event)"
      />
    }
    <router-outlet />
  </div>

  <!--app-main-footer class="footer-container" /-->
</div>
